import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getHierarchyUpload, sendNotification } from 'actions/hierarchyUpload'
import { hasAccess } from 'utils/hasAccess'

class HierarchyUpload extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    getHierarchyUpload: PropTypes.func.isRequired,
    hierarchyUpload: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    sendNotification: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Partner hierarchy upload', this.props.history, 'RW', true)
    this.props.getHierarchyUpload()
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, hierarchyUpload, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Upload hierarchy" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              initUpload={this.props.getHierarchyUpload}
              hierarchyUpload={hierarchyUpload}
              sendNotification={this.props.sendNotification}
              setErrorMessage={this.props.setErrorMessage}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  hierarchyUpload: state.hierarchyUpload,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  sendNotification,
  getHierarchyUpload,
})(HierarchyUpload))



// WEBPACK FOOTER //
// ./src/containers/HierarchyUpload.js